import React from "react";
import { Pagination } from "antd";
import PropTypes from "prop-types";

const AppsPagination = ({
  count,
  page,
  onChange,
  pageSize,
  className,
  current,
  defaultCurrent,
}) => {
  return (
    <Pagination
      simple
      component="div"
      total={count}
      pageSize={pageSize}
      className={className}
      page={page}
      current={count !== 0 ? current : 0}
      defaultCurrent={defaultCurrent}
      backIconButtonProps={{ "aria-label": "Previous Page" }}
      nextIconButtonProps={{ "aria-label": "Next Page" }}
      onChange={onChange}
      rowsPerPageOptions={[]}
    />
  );
};

export default AppsPagination;

AppsPagination.defaultProps = {
  className: "",
  pageSize: 15,
  defaultCurrent: 1,
};

AppsPagination.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
  pageSize: PropTypes.number,
};
